<template>
    <div class="view bg-light">
        <simbar-header />
        <div class="view-title bg-white">
            <div class="container px-0">
                <h2>Selecione uma Barragem</h2>
            </div>
        </div>
        <main class="container view-container p-4 card shadow-sm my-3">
            <div class="row align-items-center">
                <div
                    v-for="(dam, index) in dams"
                    :key="index"
                    class="col-md-6 col-lg-4 mb-3 text-center d-flex justify-content-center"
                >
                    <router-link :to="{ name: dam.url }" class="dam">
                        <img :src="dam.image" :alt="dam.name" />
                        <span class="dam-title text-light">{{ dam.name }}</span>
                    </router-link>
                </div>
            </div>
        </main>
        <simbar-footer />
    </div>
</template>
<script>
import SimbarHeader from "@/modules/dashboard/components/SimbarHeader";
import SimbarFooter from "@/modules/dashboard/components/SimbarFooter";
import * as camposNovos from "@/modules/campos_novos/settings";
import * as fozChapeco from "@/modules/foz_chapeco/settings";
import * as julho14 from "@/modules/julho_14/settings";

export default {
    name: "Home",
    components: {
        SimbarHeader,
        SimbarFooter
    },
    dams: [
        {
            name: fozChapeco.TITLE,
            url: fozChapeco.HOME_ROUTE_NAME,
            group: fozChapeco.GROUP_NAME,
            image: require("@/assets/images/UHEFozdoChapeco2.jpg")
        },
        {
            name: camposNovos.TITLE,
            url: camposNovos.HOME_ROUTE_NAME,
            group: camposNovos.GROUP_NAME,
            image: require("@/assets/images/UHECampoNovos2.jpg")
        },
        {
            name: julho14.TITLE,
            url: julho14.HOME_ROUTE_NAME,
            group: julho14.GROUP_NAME,
            image: require("@/assets/images/UHE14deJulho2.jpg")
        }
    ],
    computed: {
        dams() {
            if (this.$store.getters["auth/isAuthenticated"]) {
                return this.$options.dams.filter(
                    ({ group }) =>
                        this.$store.getters["auth/isSuperUser"] ||
                        this.$store.state.auth.user.groups.includes(group)
                );
            }
            return [];
        }
    }
};
</script>

<style lang="scss">
.view {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100%;
    padding-top: $navbar-height;

    .view-title {
        border-bottom: 1px solid #eeeeee;
        padding: 15px 20px;

        h2 {
            margin-bottom: 0;
        }
    }

    .navbar,
    .view-title,
    .view-container,
    .footer {
        flex: 0 1 auto;
    }

    .view-container {
        flex-grow: 1;
    }

    .dam {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 16.75rem;
        width: 16.75rem;
        border-radius: 50%;
        overflow: hidden;
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        position: relative;

        &:hover {
            cursor: pointer;

            img {
                transform: scale(1.5);
                filter: brightness(100%);
            }

            .dam-title {
                background: rgba(0, 0, 0, 0.6);
            }
        }

        img {
            display: block;
            max-height: 100%;
            vertical-align: middle;
            transition: all 0.5s ease;
            filter: brightness(50%);
        }
    }

    .dam-title {
        position: absolute;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 3px;
        padding: 0 5px;
        width: 100%;
        text-align: center;
        top: 7.625rem;
        transition: background 0.5s ease;
    }
}
</style>
